/**
 * @desc 通过业务单据获取当前用户待办任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.ActivitiTaskRequestDto>>;
export function request(body: defs.activiti.BpmActivitiTaskDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/activitiFacade/getPersonnelTaskByBusinessKeyRouteBpm`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
